var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZoomOut = function SvgZoomOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "btn_zoom-out")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-252.000000, -540.000000)",
    fill: "#737689",
    fillRule: "nonzero",
    id: "btn_zoom-out"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6012986,18.3440157 C18.3007972,18.6451507 17.9067615,18.795338 17.5125991,18.795338 C17.1184367,18.795338 16.7246544,18.6451507 16.4235194,18.3440157 L12.0959707,14.0162135 C10.8492261,14.8860324 9.33379188,15.3971762 7.69846135,15.3971762 C3.44657664,15.3971762 0,11.9503461 0,7.69846135 C0,3.44657664 3.44657664,0 7.69846135,0 C11.9503461,0 15.3971762,3.44657664 15.3971762,7.69808113 C15.3971762,9.20058779 14.9652451,10.6015754 14.2210259,11.7862173 L18.6011718,16.1666168 C19.2029349,16.7677462 19.2029349,17.743013 18.6012986,18.3440157 Z M10.2132431,8.92936348 C10.7582265,8.92936348 11.1994096,8.48792689 11.1994096,7.94319694 C11.1994096,7.39846698 10.757973,6.9570304 10.2132431,6.9570304 L8.68475463,6.9570304 L6.71242156,6.9570304 L5.18393313,6.9570304 C4.63920318,6.9570304 4.1977666,7.39846698 4.1977666,7.94319694 C4.1977666,8.48792689 4.63920318,8.92936348 5.18393313,8.92936348 L6.71242156,8.92936348 L8.68475463,8.92936348 L10.2132431,8.92936348 Z",
    id: "Combined-Shape"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-out.e29bd1df.svg";
export { ForwardRef as ReactComponent };